import { IconRadioSelected, IconRadioUnselected } from '@hubble/icons/web';
import { forwardRef } from 'react';
import { BaseSwitch } from '../shared/components/BaseSwitch/index.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Radio = forwardRef((props, ref) => jsx(BaseSwitch, {
  iconSelected: jsx(IconRadioSelected, {}),
  iconUnselected: jsx(IconRadioUnselected, {}),
  inputType: "radio",
  ref: ref,
  ...props,
  children: props.children
}));

export { Radio };
